<template>
  <app-dropdown
    placeholder="Filter by Type"
    track-by="id"
    label="label"
    :options="orderTypeSelection"
    :loading="loading"
    :disabled="dropdownDisabled"
    v-bind="attrs"
    @on-selected="onTypeSelected"
    @on-removed="onTypeRemoved"
  />
</template>

<script>
import AppDropdown from "../AppComponents/AppDropdown.vue";
import ApiMixin from "../../mixins/ApiMixin";

/**
 * The value that indicates that selecting this from the
 * dropdown means the user is trying to select all
 * order types.
 */
export const OrderTypeAllOption = {
  id: 0,
  label: "All Types"
};

export default {
  mixins: [ApiMixin],
  components: {
    AppDropdown
  },
  computed: {
    attrs() {
      const { placeholder, options, ...rest } = this.$attrs;
      return rest;
    },
    // Function to determine if the dropdown should be disabled
    dropdownDisabled() {
      if (this.loading) return true;
      if (this.attrs.disabled) return this.attrs.disabled;

      return false;
    },
    orderTypeSelection() {
      return [
        OrderTypeAllOption,
        {
          label: "Agent",
          id: "agent"
        },
        {
          label: "Office",
          id: "office"
        },
        {
          label: "Agent Extend",
          id: "agent extend"
        },
        {
          label: "Property",
          id: "property"
        },
        {
          label: "Just Sold",
          id: "property just sold"
        },
      ];
    }
  },
  methods: {
    onTypeSelected(props) {
      this.$emit("on-order-type-selected", props);
    },
    onTypeRemoved(props) {
      this.$emit("on-order-type-removed", props);
    }
  },
  inheritAttrs: false
};
</script>
